import { tagId } from '../fixture-ids';

export const tagEntries = {
  PIPELINE_TAG_CREATED: {
    entity: 'tag',
    identity: 'record',
    idKeys: ['tagId'],
    renderMode: 'diff',
    createsRecord: true,
  },
  PIPELINE_TAG_UPDATED: {
    entity: 'tag',
    identity: 'record',
    idKeys: ['tagId'],
    renderMode: 'diff',
    createsRecord: false,
  },
  // A real SQL DELETE (tags_audit_log():44-47), not a soft delete — but the row's identifying
  // fields (OLD.id, OLD.label) are a full snapshot, same shape as CREATED/UPDATED.
  PIPELINE_TAG_DELETED: {
    entity: 'tag',
    identity: 'record',
    idKeys: ['tagId'],
    renderMode: 'diff',
    createsRecord: false,
  },
};

export const tagFixtures = {
  PIPELINE_TAG_CREATED: { action: 'PIPELINE_TAG_CREATED', debugData: { tagId, tagLabel: 'production' } },
  PIPELINE_TAG_UPDATED: { action: 'PIPELINE_TAG_UPDATED', debugData: { tagId, tagLabel: 'prod' } },
  PIPELINE_TAG_DELETED: { action: 'PIPELINE_TAG_DELETED', debugData: { tagId, tagLabel: 'prod' } },
};
